class SizeErrorToast {
  static show(message) {
    let toast = document.querySelector('.size-error-toast');
    if (!toast) {
      toast = document.createElement('div');
      toast.className = 'size-error-toast';
      toast.innerHTML = `
        <span class="size-error-toast__icon" aria-hidden="true">⚠</span>
        <span class="size-error-toast__message"></span>
        <button type="button" class="size-error-toast__close" aria-label="Close">&times;</button>
      `;
      document.body.appendChild(toast);
      toast.querySelector('.size-error-toast__close').addEventListener('click', () => {
        toast.classList.remove('size-error-toast--visible');
      });
    }

    toast.querySelector('.size-error-toast__message').textContent = message;
    toast.classList.add('size-error-toast--visible');

    clearTimeout(toast._hideTimeout);
    toast._hideTimeout = setTimeout(() => {
      toast.classList.remove('size-error-toast--visible');
    }, 4000);
  }
}

window.SizeErrorToast = SizeErrorToast;